import { useRef } from 'react';

import { NotificationService } from 'services/notification-service';

interface UseMultiUpdateNotificationHandlingProps {
  feedbackKey: string;
}

export function useMultiUpdateNotificationHandling({ feedbackKey }: UseMultiUpdateNotificationHandlingProps) {
  const isLastUpdateNotificationSuccess = useRef(true);

  const resetNotificationStatusTracking = () => (isLastUpdateNotificationSuccess.current = true);

  const showUpdateNotification = (success: boolean) => {
    // If the last notification was an error and the current is a success, we don't show it
    if (!isLastUpdateNotificationSuccess.current && success) return;
    NotificationService.showResult(
      success,
      `FEED_BACK.SMART_ASSISTANT.${success ? 'SUCCESS' : 'FAILURE'}.${feedbackKey}`,
      undefined,
      undefined,
      `UPDATE_${feedbackKey}_NOTIF_ID`
    );
    isLastUpdateNotificationSuccess.current = success;
  };

  return { showUpdateNotification, resetNotificationStatusTracking };
}
